export default "__VITE_ASSET__B54Tif_W__"